import React from 'react';
import { Table } from 'react-bootstrap';

const OrderInvoiceExpandedRow = ({ invoice }) => {
  const calculateTax = line => {
    const igst = parseFloat(line.total_igst) || 0;
    const cgst = parseFloat(line.total_cgst) || 0;
    const sgst = parseFloat(line.total_sgst) || 0;

    const totalTax = igst + cgst + sgst;

    return totalTax.toFixed(2);
  };

  const calculateSummary = () => {
    const lines = invoice?.invoice_lines || [];

    const subtotalBeforeDiscountAndTax = lines.reduce((sum, line) => {
      return sum + (parseFloat(line.total_net) || 0);
    }, 0);

    const totalDiscount = lines.reduce((sum, line) => {
      return sum + (parseFloat(line.total_discount) || 0);
    }, 0);

    const totalIGST = lines.reduce((sum, line) => {
      return sum + (parseFloat(line.total_igst) || 0);
    }, 0);

    const totalCGST = lines.reduce((sum, line) => {
      return sum + (parseFloat(line.total_cgst) || 0);
    }, 0);

    const totalSGST = lines.reduce((sum, line) => {
      return sum + (parseFloat(line.total_sgst) || 0);
    }, 0);

    const shippingCharges =
      parseFloat(invoice?.shipment?.shipping_charges) || 0;

    const codCharges =
      parseFloat(invoice?.shipment?.cash_on_delivery_charges) || 0;

    const totalTax = totalIGST + totalCGST + totalSGST;

    const totalAmount =
      lines.reduce((sum, line) => {
        return sum + (parseFloat(line.total_amount) || 0);
      }, 0) +
      shippingCharges +
      codCharges;

    return {
      subtotalBeforeDiscountAndTax,
      totalDiscount,
      shippingCharges,
      codCharges,
      totalIGST,
      totalCGST,
      totalSGST,
      totalTax,
      totalAmount,
    };
  };

  const summary = calculateSummary();

  return (
    <div className="table-responsive p-3">
      <Table size="sm" className="mb-0 border">
        <thead className="bg-light">
          <tr>
            <th className="text-nowrap text-start">Item SKU Code</th>
            <th className="text-nowrap text-end">Units</th>
            <th className="text-nowrap text-end">MRP</th>
            <th className="text-nowrap text-end">
              Selling Price w/o Taxes and Discount
            </th>
            <th className="text-nowrap text-end">Taxes (%)</th>
            <th className="text-nowrap text-end">Discounts</th>
          </tr>
        </thead>
        <tbody>
          {invoice?.invoice_lines.map((line, idx) => (
            <tr key={idx}>
              <td className="text-nowrap text-start">{line.product_sku}</td>
              <td className="text-nowrap text-end">{line.quantity}</td>
              <td className="text-nowrap text-end">{line.total_net}</td>
              <td className="text-nowrap text-end">{line.total_net}</td>
              <td className="text-nowrap text-end">{calculateTax(line)}</td>
              <td className="text-nowrap text-end">{line.total_discount}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Summary Section */}
      <div className="d-flex justify-content-end mt-3">
        <Table size="sm" className="w-auto">
          <tbody>
            <tr className="border-bottom">
              <td className="text-end pe-4">
                Sub Total before Discount & Taxes
              </td>
              <td className="text-end">
                ₹{summary.subtotalBeforeDiscountAndTax.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td className="text-end pe-4">Discounts</td>
              <td className="text-end">
                (-) ₹{summary.totalDiscount.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td className="text-end pe-4">Shipping Charges</td>
              <td className="text-end">
                ₹{summary.shippingCharges.toFixed(2)}
              </td>
            </tr>
            <tr>
              <td className="text-end pe-4">COD Charges</td>
              <td className="text-end">₹{summary.codCharges.toFixed(2)}</td>
            </tr>
            {invoice?.order?.gst_type === 'igst' && (
              <tr>
                <td className="text-end pe-4">Integrated GST</td>
                <td className="text-end">₹{summary.totalIGST.toFixed(2)}</td>
              </tr>
            )}
            {invoice?.order?.gst_type === 'cgst_and_sgst' && (
              <>
                <tr>
                  <td className="text-end pe-4">Central GST</td>
                  <td className="text-end">₹{summary.totalCGST.toFixed(2)}</td>
                </tr>
                <tr>
                  <td className="text-end pe-4">State GST</td>
                  <td className="text-end">₹{summary.totalSGST.toFixed(2)}</td>
                </tr>
              </>
            )}
            <tr className="border-bottom">
              <td className="text-end pe-4">Total Tax on Sales</td>
              <td className="text-end">₹{summary.totalTax.toFixed(2)}</td>
            </tr>
            <tr className="fw-bold">
              <td className="text-end pe-4">Total Amount</td>
              <td className="text-end">₹{summary.totalAmount.toFixed(2)}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default OrderInvoiceExpandedRow;
